import {createMandatoryContext} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ContactOrAccountDetailsPanelId} from '../../../store/panels/panelStateBase';
import {AccountDetailsTrackEventHandler} from '../tracking/accountDetailsTrackingHelpers';

export interface AccountDetailsContextProps {
  panelId: ContactOrAccountDetailsPanelId;
  onTrackEvent: AccountDetailsTrackEventHandler;
}

/*
 * Context.
 */

export const [AccountDetailsContext, useAccountDetailsContext] =
  createMandatoryContext<AccountDetailsContextProps>();
